import {Backdrop, Button, Collapse, Fade, IconButton, Typography} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {Alert} from '@material-ui/lab';
import AlertTitle from '@material-ui/lab/AlertTitle';
import StandardLogo from 'Core/assets/images/StandardLogo.svg';
import {getLandingPageFooterFeatureFlag} from 'Core/ducks/featureFlag';
import {TokenRefreshSessionKeys, tokenRefresh} from 'Core/ducks/refreshToken';
import Loading from 'Shared/components/Loading';
import {LocalStorageKey, toLocalStorage} from 'Shared/utilities/localStorage';
import {OAuthTokenGeneration} from 'Core/appfabric/OAuthTokenGeneration';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getOAuthProviderVariablesExternal, getOAuthProviderVariablesInternal} from '../../../OAuthProviderVariables';
import {toggleLoginSpinner} from '../../ducks/login';
import './Login.sass';
import PortalFooterWrapper from '../Footer/PortalFooterWrapper';

export const Login = () => {
  const {isOpen, wasForceLoggedOut} = useSelector((state: ReducerState) => state.login);
  const [inactivityOpen, setInactivityOpen] = React.useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    sessionStorage.removeItem(TokenRefreshSessionKeys.SAVED_ENCRYPTED_ID);
    sessionStorage.removeItem(TokenRefreshSessionKeys.TOKEN_REFRESH_FLAG);
    if (window.location.search && !isOpen) {
      dispatch(toggleLoginSpinner(true));
      const currentURL = new URLSearchParams(window.location.search);
      const state = currentURL.get('state');
      dispatch(tokenRefresh(String(state), dispatch));
    }
    dispatch(getLandingPageFooterFeatureFlag());
  }, []);

  const initiateOAuthCodeChallengeEmployee = async () => {
    dispatch(toggleLoginSpinner(true));
    toLocalStorage(LocalStorageKey.IsEmployee)('true')();
    sessionStorage.setItem('is_employee', 'true');
    await OAuthTokenGeneration.initiateCodeChallenge(getOAuthProviderVariablesInternal());
  };
  const initiateOAuthCodeChallengeNonEmployee = async () => {
    dispatch(toggleLoginSpinner(true));
    toLocalStorage(LocalStorageKey.IsEmployee)('false')();
    sessionStorage.setItem('is_employee', 'false');
    await OAuthTokenGeneration.initiateCodeChallenge(getOAuthProviderVariablesExternal());
  };

  const openBrokerRegistration = () => {
    window.open('https://www.standard.com/ahlevb/myaccessbrokerregistration/', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Fade mountOnEnter unmountOnExit in={isOpen}>
        <Backdrop className="login-backdrop" open={isOpen}>
          <Loading />
        </Backdrop>
      </Fade>

      <header className="login__header">
        <div className="login__logo-container">
          <img src={StandardLogo} className="login__logo" alt="Standard Insurance Logo" />
        </div>
      </header>
      <main className="login__main">
        <div className="login__welcome-form">
          <div className="login__login-buttons-container">
            <div className="login__welcome-text-container">
              <Typography variant="h1" className="login__welcome-text-header">
                Welcome to <strong>MyAccess</strong>
              </Typography>
              <Typography className="login__welcome-text-description">
                MyAccess is your one-stop resource to help manage your book of business, including account information,
                policies, claims, compensation and more.
              </Typography>
            </div>
            <Button
              id="independent-agent-login-button"
              className="login__sign-in-button"
              variant="contained"
              disableElevation
              onClick={() => initiateOAuthCodeChallengeNonEmployee()}
            >
              Independent Broker Login
            </Button>
            <Button
              id="allstate-employee-login-button"
              className="login__sign-in-button"
              variant="contained"
              disableElevation
              onClick={() => initiateOAuthCodeChallengeEmployee()}
            >
              AHL Channel Login
            </Button>
            <div className="login__request-access-container">
              <button
                type="button"
                className="login__request-access-link"
                onClick={openBrokerRegistration}
              >
                New User? Request Access
              </button>
            </div>
          </div>
          <Collapse style={{marginBottom: '1em'}} in={wasForceLoggedOut && inactivityOpen} mountOnEnter unmountOnExit>
            <div className="login__welcome-form">
              <Alert
                severity="error"
                variant="filled"
                action={
                  <IconButton aria-label="close" color="inherit" size="small" onClick={() => setInactivityOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                }
              >
                <AlertTitle>
                  <strong>You have been logged out due to inactivity.</strong>
                </AlertTitle>
              </Alert>
            </div>
          </Collapse>
        </div>
      </main>
      <PortalFooterWrapper />
    </>
  );
};

export default Login;
